import { createVNode as l, mergeProps as i } from "vue";
import m from "../node_modules/@pf-ui/pf-icon-svg/es/asn/LogoFilled.js";
import s from "../components/PfIcon.js";
const o = (r, e) => {
  const t = {
    ...r,
    ...e.attrs
  };
  return l(s, i(t, {
    icon: m
  }), null);
};
o.displayName = "LogoFilled";
o.inheritAttrs = !1;
export {
  o as default
};
